import React from 'react';
import { DropdownMenuItem, ButtonLink } from "../..";
export var ApplicationMenuButton = function (_a) {
    var url = _a.url, appName = _a.appName, id = _a.id;
    if (!url)
        return null;
    return (React.createElement(ButtonLink, { id: id, target: "_blank", to: url, lss: {
            bg: 'none',
            border: 'none',
            px: 'xs',
            py: 'sm',
            ':not([disabled]):hover': {
                textDecoration: 'none',
                bg: 'gray300'
            }
        } },
        React.createElement(DropdownMenuItem, { text: appName })));
};
//# sourceMappingURL=ApplicationMenuButton.js.map